<template>
  <div>
    <div class="container mb-2">
      <SectionHeader
        title="Application Information"
        :details="
          'This section contains information collected during the submission process of your application. Please only change pertinent information.'
        "
        :includeDisclaimer="false"
      />
      <div class="row">
        <div class="col mt-2">
          <label>Submission Date</label>
          <input
            type="date"
            class="form-control"
            placeholder="Submission Date"
            :value="submissionDate"
            @change="e => handleValueChanged('submissionDate', e.target.value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/components/Application/SectionHeader";

export default {
  components: {
    SectionHeader
  },
  props: {
    submissionDate: {
      type: String,
      require: true,
      default: () => {
        return "";
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  methods: {
    handleValueChanged(name, value) {
      this.onValueChanged("root", name, value);
    }
  }
};
</script>
